<!----------------------------   Program description   ----------------------------
- Vue Name ID   :gulummaShopPopup
- Vue Name  :gulummaShopPopup
- Author      :노희원
- Create Date :
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div>
    <a href="http://hanalim.firstmall.kr/goods/catalog?code=00370008" target="_blank">
      <img src="../../../assets/i5gam/images/i5gamBanner230412-1.png"
           alt="걸음마 쇼핑몰" style="width: 450px;"/>
    </a>
    <div style="padding:9px 30px 0;height:40px;border-top:1px solid #e0e0e0;background:#f3f3f3;text-align:right;box-sizing:border-box;">
      <input type="checkbox" id="sort"
             true-value="Y" false-value="N"
             v-model="todayShowAt"
             @change="noShowToday">
      <label for="sort" class="font-size14">
        <span class="box mgr5"></span> 오늘 하루 보지않기
      </label>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
   * 2.1. Import
   *======================================================================================*/
export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  name: 'gulummaShopPopup',
  props: ['index'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      todayShowAt: 'N'
    }
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    noShowToday: function (){
      this.setCookie("gulummaShop",'done',1);
      this.closePopup();
    },
    setCookie: function (name, value, days) {
      let todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + days);
      document.cookie = name + "=" + escape(value) + "; path=/; expires=" + todayDate.toGMTString() + ";"
    },
    closePopup: function(){
      this.$store.commit('closePopup', this.index);
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
  }
}
</script>

<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>

</style>
